import { createContext } from 'react';

import { AuthContextProps } from './AuthContext.types';

export const AuthContext = createContext<AuthContextProps | undefined>(undefined);
